module.exports = __webpack_public_path__ + "img/partners_5.67c39ce4.png";